import React, { useState, useEffect } from "react";
import DataTable from "../../components/DataTable";
import SnackbarAlert from "../../components/SnackbarAlert";
import { Box, TextField, Tooltip, Typography, Button, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { webEndPoint } from '../../constants/globalConstants';
import { makeRequest } from "../../services/api";
export default function TaxMaster() {
    const [datasource, setDatasource] = useState([]);
    const [search, setSearch] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [editState, setEditState] = useState(null);
    const [sizeName, setSizeName] = useState("");
    const [taxvalue, setTaxvalue] = useState(0);
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        fetchsizes();
    }, []);
    const fetchsizes = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "tax";
            const response = await makeRequest("get", url);
            if (response) {
                setDatasource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const openAddModal = () => {
        setEditState(null);
        setSizeName("");
        setOpenModal(true);
    };
    const handleEdit = (size) => {
        setEditState(size);
        setTaxvalue(size.tax_value);
        setSizeName(size.tax_name);
        setOpenModal(true);
    };
    const handleClose = () => {
        setOpenModal(false);
        setSizeName("");
    };
    const handleSave = async () => {
        if (!sizeName.trim() && !taxvalue.trim()) {
            setMessage("Tax Name & Tax Value Required");
            setSnackbar(true);
            return;
        }
        setLoading(true);
        try {
            if (editState) {
                const sizeEditData = {
                    tax_name: sizeName,
                    tax_value: taxvalue
                };
                try {
                    let url = webEndPoint + "tax/" + editState.rfId;
                    const response = await makeRequest("put", url, sizeEditData);
                    if (response) {
                        setLoading(false);
                        setMessage("Tax Updated Successfully");
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            } else {
                const sizeAddData = {
                    tax_name: sizeName,
                    tax_value: taxvalue
                };
                try {
                    let url = webEndPoint + "tax";
                    const response = await makeRequest("post", url, sizeAddData);
                    if (response) {
                        setMessage("Tax Added Successfully");
                    }
                } catch (err) {
                    if (err?.message) {
                        setMessage(err.message);
                    } else {
                        setMessage("Something went wrong");
                    }
                } finally {
                    setLoading(false);
                }
            }
            fetchsizes();
            setSnackbar(true);
            setOpenModal(false);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const filteredState = datasource?.filter((d) =>
        d?.tax_name?.toLowerCase().includes(search?.toLowerCase())
    );
    const columns = ["S.No", "Tax Name", "Tax Value (%)", "Action"];
    const rows = filteredState?.map((sizes, index) => [index + 1, sizes.tax_name, sizes.tax_value,
    <Box>
        <Tooltip title="Edit Tax">
            <Button variant="contained" color="primary" onClick={() => handleEdit(sizes)}>Edit</Button>
        </Tooltip>
    </Box>
    ]);
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 500 }}>Tax Master</Typography>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", mb: 2, width: "100%", }}>
                <TextField label="Search Tax" size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", sm: "70%", md: 600 } }} />
                <Button variant="contained" startIcon={<AddIcon />} onClick={openAddModal} sx={{ width: { xs: "100%", sm: "auto" }, }}>Add Tax</Button>
            </Box>
            <DataTable columns={columns} rows={rows} />
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
            <Dialog open={openModal} onClose={handleClose} fullWidth maxWidth="sm">
                <DialogTitle> {editState ? "Edit Tax" : "Add Tax"}</DialogTitle>
                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                    <TextField label="Tax Name" value={sizeName} onChange={(e) => setSizeName(e.target.value)} sx={{ mt: 2 }} fullWidth />
                    <TextField label="Tax Value" value={taxvalue} onChange={(e) => {
                        const value = e.target.value; if (/^\d*\.?\d*$/.test(value)) { setTaxvalue(value); }
                    }} sx={{ mt: 2 }} fullWidth />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" onClick={handleSave}>Save</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}